import React from "react"
import PropTypes from "prop-types"
import { Field } from "redux-form/immutable"

import SearchifySelectField from "app/static/frontend/forms/containers/SearchifySelectField"

import { BULK_ACTIONS_FORM_KEY } from "shared/imports/sharedConstants"
import { constants } from "shared/forms/BulkActions/constants"

// generic component
export const BulkActionsMerge = (props) => {
    const qdtLabel = DjangIO.app.models.QuorumDataType.by_value(props.quorumDataType).singular

    return (
        <div className="bulk-actions-console-merge-form" data-cy="bulk-actions-console-merge-form">
            {
                <Field
                    key="merge"
                    // the name/key that will be stored in the reduxForm Immutable map
                    name="merge"
                    // the tooltip hover text that will be displayed to the right of the label
                    label={`Choose the parent ${qdtLabel} that all selected ${qdtLabel}s will be merged into.`}
                    tooltipText={
                        `This ${qdtLabel} will act as the parent, ` +
                        `while your ${qdtLabel}(s) selected further below will be the objects that are merged and archived.`
                    }
                    className="bulk-actions-form-merge"
                    component={SearchifySelectField}
                    selectComponent={props.selectComponent}
                    props={{
                        // change is inherited from the reduxForm() wrapper in
                        // app/static/frontend/search-new/containers/BulkActions/BulkActionsConsole
                        change: props.change,
                        formKey: BULK_ACTIONS_FORM_KEY,
                        model: DjangIO.modelAtPath(
                            DjangIO.app.models.QuorumDataType.by_value(props.quorumDataType).data_model,
                        ),
                        name: "merge",
                        permanentFilter: props.selectComponentPermanentFilters,
                    }}
                    customProps={constants.CUSTOM_SEARCHIFY_FORM_PROPS}
                />
            }
        </div>
    )
}

BulkActionsMerge.propTypes = {
    // from app/static/frontend/search-new/components/BulkActions/BulkActionsConsole
    change: PropTypes.func.isRequired,
    quorumDataType: PropTypes.number.isRequired,
    // from app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsMerge
    selectComponent: PropTypes.func.isRequired,
}

export default BulkActionsMerge
